document.addEventListener("DOMContentLoaded", function () {
  class UpsellSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderRef = this.querySelector("[data-slider]");
      this.nextRef = this.querySelector('[data-navigation="next"]') || null;
      this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
      this.paginationRef = this.querySelector("[data-pagination]") || null;
      this.initSlider = this.initSlider.bind(this);
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.swiper = new Swiper(this.sliderRef, {
        // Optional parameters
        loop: false,
        spaceBetween: 8,
        autoplay: false,
        slidesPerView: 1,
        freeMode: true,
        pagination: {
          el: this.paginationRef,
          clickable: true,
        },
        navigation: {
          nextEl: this.nextRef,
          prevEl: this.previousRef,
        },
      });
    }

    disconnectedCallback() {
      this.swiper.destroy();
    }
  }
  customElements.define("upsell-slider", UpsellSlider);
});
